import { Component, Output, EventEmitter, Input, ViewChildren, ViewContainerRef,
    QueryList, TemplateRef } from '@angular/core';

import { DynamicComponent, HisAuthService, HisUiService, HisNotificationService } from 'hisng';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { GlobalIdentifier } from 'app/fs/res/publication/model/global-identifier';

@Component( {
    selector: 'res-identifier-panel',
    templateUrl: './identifier-panel.component.html',
    providers: [ProviderManager.getComponentProvider(IdentifierPanelComponent)],
} )
export class IdentifierPanelComponent {
    @Input() globalIdentifiers: GlobalIdentifier[];
    @Input() dynamicComponent: DynamicComponent = new DynamicComponent(); // dynamicComponent null will reset formGroup
    @Input() context: string;
    @Input() dDKey: string;
    @Input() customContentTemplate: TemplateRef<any>;
    @Output() globalIdentifiersChange = new EventEmitter();
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    public identifierVisibility = false;
    public globalIdentifier: GlobalIdentifier;
    private editIndexToRemember: number = null;

    constructor( public auth: HisAuthService,
        private hisUiService: HisUiService,
        private notificationService: HisNotificationService ) {
    }

    public addIdentifier() {
        this.globalIdentifier = new GlobalIdentifier();
        this.editIndexToRemember = null;
        this.identifierVisibility = true;
    }

    public deleteIdentifier( index: number ) {
        this.globalIdentifiers.splice( index, 1 );
        this.globalIdentifiersChange.emit( this.globalIdentifiers );
    }

    public editIdentifier( identifier: GlobalIdentifier, index: number ) {
        this.editIndexToRemember = index;
        this.globalIdentifier = JSON.parse( JSON.stringify( identifier ) );
        this.identifierVisibility = true;
    }

    public globalIdentifierChange( event: GlobalIdentifier ): void {
        event.id = -1; // temp id to differ new and edit entries heading
        if ( this.editIndexToRemember === null ) {
            if ( !this.globalIdentifiers ) {
                this.globalIdentifiers = [];
            }
            this.globalIdentifiers.push(event);
        } else {
            this.globalIdentifiers[this.editIndexToRemember] = event;
            this.editIndexToRemember = null;
        }
        this.warnMessageGlobalIdentifierTypeAlreadyAssigned( event );
        this.globalIdentifiersChange.emit( this.globalIdentifiers );
    }

    // find if identifier type already assigned in other identifier - warn message
    public warnMessageGlobalIdentifierTypeAlreadyAssigned( identifier: GlobalIdentifier ) {
        if ( identifier.globalIdentifierType ) {
            let containedIdentifiers = this.globalIdentifiers.filter(
                ( globalIdentifier: GlobalIdentifier ) =>
                    globalIdentifier.globalIdentifierType.hiskeyId === identifier.globalIdentifierType.hiskeyId );
            if ( containedIdentifiers.length > 1 ) {
                this.notificationService.warn(
                    this.hisUiService.translate( 'fs.res.publication.warning.identifer',
                        containedIdentifiers[0].globalIdentifierType.defaulttext ),
                    this.hisUiService.translate( 'fs.res.common.service.warn' )
                );
            }
        }
    }

}
